import type { DossierDe, PossibleDuJour } from '../../partage/api/types';

/**
 * Les trois façons de trier « Chercher une tâche » dans « Préparer ma journée » (ticket 03 du
 * chantier telephone, décision d'Igor du 2026-09-28 ; le panneau refait au chantier
 * `revue-design`, ticket 06). Sans rendu.
 *
 * La liste du serveur (`possiblesPourLeJour`) arrive déjà rangée dans l'ordre de la flottaison
 * (chantier `flottaison-suite`, ticket 05) ; les deux autres tris se font sur elle, sans jamais
 * la recalculer : à égalité, l'ordre du serveur tient.
 */

export type Tri = 'flotte' | 'projet' | 'rapides';

export const TRIS: Tri[] = ['flotte', 'projet', 'rapides'];

/** « Ce qui flotte » : la liste du serveur, telle quelle. */
export function dansLOrdreDuServeur(possibles: readonly PossibleDuJour[]): PossibleDuJour[] {
  return [...possibles];
}

/** « Les plus rapides » : les plus courtes d'abord ; à égalité, l'ordre du serveur. */
export function lesPlusRapides(possibles: readonly PossibleDuJour[]): PossibleDuJour[] {
  return possibles
    .map((p, rang) => ({ p, rang }))
    .sort((a, b) => a.p.minutes - b.p.minutes || a.rang - b.rang)
    .map((x) => x.p);
}

/** Un projet et ses tâches possibles, dans l'ordre du serveur. `dossier` nul : les tâches sans projet. */
export interface GroupeDuJour {
  cle: string;
  dossier: DossierDe;
  taches: PossibleDuJour[];
}

/**
 * « Par projet » : un groupe par projet, dans l'ordre où sa première tâche vient dans la liste
 * du serveur (le projet qui flotte le plus haut en premier). Les tâches sans projet font un
 * groupe à elles, rangé de la même façon.
 */
export function parProjet(possibles: readonly PossibleDuJour[]): GroupeDuJour[] {
  const groupes = new Map<string, GroupeDuJour>();
  for (const p of possibles) {
    const cle = p.dossier?.id ?? '';
    const groupe = groupes.get(cle);
    if (groupe) groupe.taches.push(p);
    else groupes.set(cle, { cle, dossier: p.dossier, taches: [p] });
  }
  return [...groupes.values()];
}

/** Combien de tâches d'un groupe sont choisies. */
export function choisiesDans(groupe: GroupeDuJour, choisis: readonly string[]): number {
  return groupe.taches.filter((t) => choisis.includes(t.id)).length;
}
